// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,900;1,100&family=Roboto+Slab&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,900;1,100&family=Noto+Sans:wght@500&family=Roboto+Slab&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsCont{

    min-height: 95vh;
    margin: 0;
    
    overflow: auto;
    padding: 10px;

}
@keyframes gradient {
    0% {
        background-position: 0% 0%;
    }
    50% {
        background-position: 100% 100%;
    }
    100% {
        background-position: 0% 0%;
    }
}
.submitLogin {
    font-family: 'Roboto Slab', serif;
    background-color: #08d;
    border-radius: 12px;
    border: 0;
    box-sizing: border-box;
    color: #eee;
    cursor: pointer;
    font-size: 18px;
    height: 50px;
    margin-top: 20px;
    text-align: center;
}
.submitLogin:hover{
    background-color: #08d;

}
.submitLogin:active {
    background-color: #06b;
}

.formContSettings h1{
    font-size: 25px;
    margin: 0;
}
.ContInfUser{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap:10px;
}
.Cont{
    display: flex;

}
.formContSettings h1{
    text-align: center;
    margin-bottom: 20px;
}
.formContSettings{
    
    font-family: 'Noto Sans', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap:10px;
    
    border-radius: 20px;

    box-sizing: border-box;
    width: 100%;
    padding: 10px;
}
.formContSettings label{
    color:white;
    font-size: large;
}
.formContSettings input::placeholder{
    font-size: 15px;
}
.input-container {
    height: 70px;
    position: relative;
    width: 100%;
}

.ic1 {
    margin-top: 40px;
}

.ic2 {
    margin-top: 30px;
}

.formContSettings input {
    background-color: #483e8440;
    border-radius: 12px;
    border: 0;
    box-sizing: border-box;
    color: #eee;
    font-size: 20px;
    
    outline: 0;
    /*padding: 4px 20px 0;*/
    width: 100%;
    padding: 5px;
    padding-left: 15px;
}
.formContSettings input {
    color:white;
}
.formContSettings input::placeholder{
    color:#ffffffbd;
}

.cut {
    background-color: #15172b;
    border-radius: 10px;
    height: 20px;
    left: 20px;
    position: absolute;
    top: -20px;
    transform: translateY(0);
    transition: transform 200ms;
    width: 76px;
}

.cut-short {
    width: 50px;
}

.placeholder {
    color: #65657b;
    font-family: sans-serif;
    left: 20px;
    line-height: 14px;
    pointer-events: none;
    position: absolute;
    transform-origin: 0 50%;
    transition: transform 200ms, color 200ms;
    top: 20px;
}
.btnChangeLogin {
    background-image: linear-gradient(to right, #DA22FF 0%, #9733EE  51%, #DA22FF  100%);
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btnChangeLogin:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

.cont{
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    background-color: #252c67;
    padding:20px;
    border-radius: 10px;
    width: 100%;

}
img{
    margin-bottom: 0;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.previous{
    margin-right: 50px;
}
.next{
    margin-left: 50px;
}
.perec{
    font-size: 55px;
    color: #5C62EC;

}


.accept {
    width: 150px;
    height:50px;
    border-radius:180px;
    position:relative;
    left:calc(50% - 75px);
    top:calc(50% - 25px);
    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
    cursor:pointer;
    line-height:12px;
    color:black;
    letter-spacing: 2px;
    font-family: "Montserrat", sans-serif;

}



.accept:hover:before {
    opacity:1;
    transition: 0.3s opacity ease-in-out;
    filter:blur(25px);
    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
}
.container-setting{
    display: flex;
    align-items: center;
}

@media screen and (max-width: 396px){
    .container-setting i{
        font-size: 40px;
    }
}
@media screen and (max-width: 1000px) {
    .settingsCont{

        margin:0;
        margin-top: 60px;
    }
    .cont{
        padding:10px;
    }
    .previous{
        margin-right: 20px;
    }
    .next{
        margin-left:20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/Pages/Settings/settings.css"],"names":[],"mappings":"AAGA;;IAEI,gBAAgB;IAChB,SAAS;;IAET,cAAc;IACd,aAAa;;AAEjB;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,sBAAsB;;AAE1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;;AAEjB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;;IAER,mBAAmB;;IAEnB,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,eAAe;;IAEf,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,SAAS;AACb;AACA;IACI,oFAAoF;IACpF,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;;AAElB;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;IACpB,0GAA0G;IAC1G,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,qCAAqC;;AAEzC;;;;AAIA;IACI,SAAS;IACT,oCAAoC;IACpC,iBAAiB;IACjB,0GAA0G;AAC9G;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;;QAEI,QAAQ;QACR,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;;AAEJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,900;1,100&family=Roboto+Slab&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,900;1,100&family=Noto+Sans:wght@500&family=Roboto+Slab&display=swap');\r\n\r\n.settingsCont{\r\n\r\n    min-height: 95vh;\r\n    margin: 0;\r\n    \r\n    overflow: auto;\r\n    padding: 10px;\r\n\r\n}\r\n@keyframes gradient {\r\n    0% {\r\n        background-position: 0% 0%;\r\n    }\r\n    50% {\r\n        background-position: 100% 100%;\r\n    }\r\n    100% {\r\n        background-position: 0% 0%;\r\n    }\r\n}\r\n.submitLogin {\r\n    font-family: 'Roboto Slab', serif;\r\n    background-color: #08d;\r\n    border-radius: 12px;\r\n    border: 0;\r\n    box-sizing: border-box;\r\n    color: #eee;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    height: 50px;\r\n    margin-top: 20px;\r\n    text-align: center;\r\n}\r\n.submitLogin:hover{\r\n    background-color: #08d;\r\n\r\n}\r\n.submitLogin:active {\r\n    background-color: #06b;\r\n}\r\n\r\n.formContSettings h1{\r\n    font-size: 25px;\r\n    margin: 0;\r\n}\r\n.ContInfUser{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap:10px;\r\n}\r\n.Cont{\r\n    display: flex;\r\n\r\n}\r\n.formContSettings h1{\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n.formContSettings{\r\n    \r\n    font-family: 'Noto Sans', sans-serif;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap:10px;\r\n    \r\n    border-radius: 20px;\r\n\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    padding: 10px;\r\n}\r\n.formContSettings label{\r\n    color:white;\r\n    font-size: large;\r\n}\r\n.formContSettings input::placeholder{\r\n    font-size: 15px;\r\n}\r\n.input-container {\r\n    height: 70px;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.ic1 {\r\n    margin-top: 40px;\r\n}\r\n\r\n.ic2 {\r\n    margin-top: 30px;\r\n}\r\n\r\n.formContSettings input {\r\n    background-color: #483e8440;\r\n    border-radius: 12px;\r\n    border: 0;\r\n    box-sizing: border-box;\r\n    color: #eee;\r\n    font-size: 20px;\r\n    \r\n    outline: 0;\r\n    /*padding: 4px 20px 0;*/\r\n    width: 100%;\r\n    padding: 5px;\r\n    padding-left: 15px;\r\n}\r\n.formContSettings input {\r\n    color:white;\r\n}\r\n.formContSettings input::placeholder{\r\n    color:#ffffffbd;\r\n}\r\n\r\n.cut {\r\n    background-color: #15172b;\r\n    border-radius: 10px;\r\n    height: 20px;\r\n    left: 20px;\r\n    position: absolute;\r\n    top: -20px;\r\n    transform: translateY(0);\r\n    transition: transform 200ms;\r\n    width: 76px;\r\n}\r\n\r\n.cut-short {\r\n    width: 50px;\r\n}\r\n\r\n.placeholder {\r\n    color: #65657b;\r\n    font-family: sans-serif;\r\n    left: 20px;\r\n    line-height: 14px;\r\n    pointer-events: none;\r\n    position: absolute;\r\n    transform-origin: 0 50%;\r\n    transition: transform 200ms, color 200ms;\r\n    top: 20px;\r\n}\r\n.btnChangeLogin {\r\n    background-image: linear-gradient(to right, #DA22FF 0%, #9733EE  51%, #DA22FF  100%);\r\n    margin: 10px;\r\n    padding: 15px 45px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    color: white;\r\n    box-shadow: 0 0 20px #eee;\r\n    border-radius: 10px;\r\n    display: block;\r\n}\r\n\r\n.btnChangeLogin:hover {\r\n    background-position: right center; /* change the direction of the change here */\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n\r\n.cont{\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    align-items: center;\r\n    background-color: #252c67;\r\n    padding:20px;\r\n    border-radius: 10px;\r\n    width: 100%;\r\n\r\n}\r\nimg{\r\n    margin-bottom: 0;\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none; /* Safari */\r\n    -khtml-user-select: none; /* Konqueror HTML */\r\n    -moz-user-select: none; /* Old versions of Firefox */\r\n    -ms-user-select: none; /* Internet Explorer/Edge */\r\n    user-select: none;\r\n}\r\n.previous{\r\n    margin-right: 50px;\r\n}\r\n.next{\r\n    margin-left: 50px;\r\n}\r\n.perec{\r\n    font-size: 55px;\r\n    color: #5C62EC;\r\n\r\n}\r\n\r\n\r\n.accept {\r\n    width: 150px;\r\n    height:50px;\r\n    border-radius:180px;\r\n    position:relative;\r\n    left:calc(50% - 75px);\r\n    top:calc(50% - 25px);\r\n    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);\r\n    cursor:pointer;\r\n    line-height:12px;\r\n    color:black;\r\n    letter-spacing: 2px;\r\n    font-family: \"Montserrat\", sans-serif;\r\n\r\n}\r\n\r\n\r\n\r\n.accept:hover:before {\r\n    opacity:1;\r\n    transition: 0.3s opacity ease-in-out;\r\n    filter:blur(25px);\r\n    background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);\r\n}\r\n.container-setting{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n@media screen and (max-width: 396px){\r\n    .container-setting i{\r\n        font-size: 40px;\r\n    }\r\n}\r\n@media screen and (max-width: 1000px) {\r\n    .settingsCont{\r\n\r\n        margin:0;\r\n        margin-top: 60px;\r\n    }\r\n    .cont{\r\n        padding:10px;\r\n    }\r\n    .previous{\r\n        margin-right: 20px;\r\n    }\r\n    .next{\r\n        margin-left:20px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
